import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { AccordionContainer } from "@faire/retailer-visitor-shared/views/product/ProductDescriptionAccordions/AccordionContainer";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { Button } from "@faire/web--source/slate/Button";
import { Globe } from "@faire/web--source/slate/icons/foundation/Globe";
import { Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useState } from "@faire/web--source/ui/hooks/useState";
import { trackProductInfoProductDescriptionAccordionExpandAboutThisProductSectionClick } from "@faire/web-api--source/events/productInfo/click/productDescriptionAccordionExpandAboutThisProductSection";
import { observer } from "mobx-react";
import React from "react";
var INITIAL_NUMBER_OF_LINES_SHOWN = 5;
var ProductDescriptionAccordionBase = function(param) {
    var descriptionInformationSection = param.descriptionInformationSection;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useState = _sliced_to_array(useState(false), 2), showOriginal = _useState[0], setShowOriginal = _useState[1];
    var title = strictLocalize({
        id: "FI9DM2",
        defaultMessage: [
            {
                type: 0,
                value: "About this product"
            }
        ]
    });
    var entries = descriptionInformationSection === null || descriptionInformationSection === void 0 ? void 0 : descriptionInformationSection.entries;
    var getTranslatedDescription = function() {
        var _entries_map_filter;
        var translatedEntries = (_entries_map_filter = entries === null || entries === void 0 ? void 0 : entries.map(function(entry) {
            var _entry_text, _entry_text1;
            var _entry_text_translated;
            return (_entry_text_translated = (_entry_text = entry.text) === null || _entry_text === void 0 ? void 0 : _entry_text.translated) !== null && _entry_text_translated !== void 0 ? _entry_text_translated : (_entry_text1 = entry.text) === null || _entry_text1 === void 0 ? void 0 : _entry_text1.original;
        }).filter(isNotUndefined)) !== null && _entries_map_filter !== void 0 ? _entries_map_filter : [];
        return translatedEntries.join("\n");
    };
    var translatedDescription = getTranslatedDescription();
    if (!translatedDescription) {
        return null;
    }
    var getOriginalDescription = function() {
        var _entries_map_filter;
        var originalEntries = (_entries_map_filter = entries === null || entries === void 0 ? void 0 : entries.map(function(entry) {
            var _entry_text;
            return (_entry_text = entry.text) === null || _entry_text === void 0 ? void 0 : _entry_text.original;
        }).filter(isNotUndefined)) !== null && _entries_map_filter !== void 0 ? _entries_map_filter : [];
        return originalEntries.join("\n");
    };
    var originalDescription = getOriginalDescription();
    var toggleLanguage = function(e) {
        e.stopPropagation();
        setShowOriginal(function(value) {
            return !value;
        });
    };
    var getToggleText = function() {
        if (showOriginal) {
            return strictLocalize({
                id: "+s12vg",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Translate"
                    }
                ]
            });
        }
        return strictLocalize({
            id: "67jGnm",
            defaultMessage: [
                {
                    type: 0,
                    value: "Show Original Language"
                }
            ]
        });
    };
    var getAuxiliarTranslationText = function() {
        if (showOriginal) {
            return strictLocalize({
                id: "SXFM2i",
                defaultMessage: [
                    {
                        type: 0,
                        value: "This info is in its original language."
                    }
                ]
            });
        }
        return strictLocalize({
            id: "mMUVfv",
            defaultMessage: [
                {
                    type: 0,
                    value: "This info has been automatically translated."
                }
            ]
        });
    };
    var renderToggleLanguageButton = function() {
        if (!originalDescription) {
            return undefined;
        }
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Spacer, {
                    height: 12
                }),
                /*#__PURE__*/ _jsxs(Row, {
                    gap: "1x",
                    children: [
                        /*#__PURE__*/ _jsx(Globe, {}),
                        /*#__PURE__*/ _jsxs(Typography, {
                            children: [
                                getAuxiliarTranslationText(),
                                " ",
                                /*#__PURE__*/ _jsx(Button, {
                                    variant: "tertiary",
                                    onClick: toggleLanguage,
                                    children: getToggleText()
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    var getDescription = function() {
        if (originalDescription === null) {
            return translatedDescription;
        }
        return showOriginal ? originalDescription : translatedDescription;
    };
    return /*#__PURE__*/ _jsx(AccordionContainer, {
        title: title,
        text: getDescription(),
        maxNumberOfLinesShownWhenCollapsed: INITIAL_NUMBER_OF_LINES_SHOWN,
        visibleComponent: renderToggleLanguageButton(),
        onExpandAccordionItem: trackProductInfoProductDescriptionAccordionExpandAboutThisProductSectionClick
    });
};
export var ProductDescriptionAccordion = observer(ProductDescriptionAccordionBase);
